import { render, staticRenderFns } from "./UnauthorisedParkingEdit.vue?vue&type=template&id=65faeefe"
import script from "./UnauthorisedParkingEdit.vue?vue&type=script&lang=js"
export * from "./UnauthorisedParkingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports